export default __webpack_public_path__ + "static/media/4065.385c9f75.svg";